var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursor01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13L19 19M17.9642 10.7513L12.9534 12.4532C12.8164 12.4997 12.7479 12.523 12.691 12.5622C12.6405 12.5968 12.5968 12.6405 12.5622 12.691C12.523 12.7479 12.4997 12.8164 12.4532 12.9534L10.7513 17.9642C10.5403 18.5855 10.4348 18.8961 10.2698 18.9901C10.1268 19.0715 9.95293 19.0773 9.8048 19.0057C9.63386 18.9231 9.50768 18.6203 9.25533 18.0145L3.74711 4.79324C3.51295 4.23121 3.39588 3.95019 3.45284 3.77438C3.50227 3.62184 3.62184 3.50227 3.77438 3.45284C3.95019 3.39588 4.23121 3.51295 4.79324 3.74711L18.0145 9.25533C18.6203 9.50768 18.9231 9.63386 19.0057 9.8048C19.0773 9.95293 19.0715 10.1268 18.9901 10.2698C18.8961 10.4348 18.5855 10.5403 17.9642 10.7513Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor01);
export default __webpack_public_path__ + "static/media/cursor-01.c66289eaa3f40be6f1d20740d05beb83.svg";
export { ForwardRef as ReactComponent };